module.exports = __webpack_public_path__ + "static/img/6.b6810a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/6.png
// module id = OdVv
// module chunks = 1